const mediaItems = [
  {
    title: '长相思',
    subtitle: '古装神话 · 热播中',
    desc: '杨紫、张晚意领衔主演，上古神话背景下的大荒世界传奇，虐心与深情交织。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20period%20fantasy%20drama%20scene%20with%20elegant%20hanfu%20costumes%2C%20ancient%20Chinese%20palace%20setting%2C%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20soft%20dreamy%20atmosphere%2C%20epic%20storytelling%20mood&width=800&height=450&seq=media-kk-01&orientation=landscape',
    alt: '长相思电视剧预览',
    tag: '热播',
  },
  {
    title: '莲花楼',
    subtitle: '武侠探案 · 全集上线',
    desc: '成毅、曾舜晞主演，江湖奇案与侠义精神的完美融合，悬疑推理层层剥开。',
    img: 'https://readdy.ai/api/search-image?query=martial%20arts%20mystery%20drama%20scene%2C%20ancient%20Chinese%20warrior%20in%20flowing%20robes%2C%20misty%20mountain%20landscape%2C%20dramatic%20cinematic%20lighting%2C%20warm%20amber%20and%20teal%20tones%2C%20atmospheric%20depth&width=800&height=450&seq=media-kk-02&orientation=landscape',
    alt: '莲花楼电视剧预览',
    tag: '全集',
  },
  {
    title: '长风渡',
    subtitle: '古装商战 · 完结',
    desc: '白敬亭、宋轶演绎乱世中的商战传奇与旷世爱恋，口碑爆棚。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%2C%20couple%20in%20elegant%20traditional%20costumes%2C%20ancient%20marketplace%20background%2C%20warm%20golden%20hour%20lighting%2C%20romantic%20cinematic%20mood%2C%20soft%20bokeh&width=800&height=450&seq=media-kk-03&orientation=landscape',
    alt: '长风渡电视剧预览',
    tag: '完结',
  },
  {
    title: '七时吉祥',
    subtitle: '仙侠爱情 · 新剧',
    desc: '杨超越、丁禹兮主演，七世轮回的仙侠爱情故事，甜虐交织。',
    img: 'https://readdy.ai/api/search-image?query=xianxia%20fantasy%20drama%20with%20ethereal%20celestial%20palace%2C%20flowing%20silk%20robes%20in%20pastel%20colors%2C%20floating%20clouds%20and%20mist%2C%20dreamy%20atmospheric%20lighting%2C%20romantic%20fantasy%20mood&width=800&height=450&seq=media-kk-04&orientation=landscape',
    alt: '七时吉祥电视剧预览',
    tag: '新剧',
  },
  {
    title: '玉骨遥',
    subtitle: '仙侠巨制 · 4K修复',
    desc: '肖战、任敏主演，空桑王朝的仙侠史诗，4K画质升级回归。',
    img: 'https://readdy.ai/api/search-image?query=epic%20Chinese%20fantasy%20drama%20scene%2C%20mystical%20ancient%20temple%20in%20clouds%2C%20warrior%20in%20white%20flowing%20robes%2C%20dramatic%20sunset%20sky%2C%20cinematic%20composition%2C%20rich%20contrast%20lighting&width=800&height=450&seq=media-kk-05&orientation=landscape',
    alt: '玉骨遥电视剧预览',
    tag: '4K',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1300px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          精彩预告
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          精选好剧，即刻开看
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/35 transition-colors flex items-center justify-center">
                  <span className="w-14 h-14 flex items-center justify-center rounded-full bg-background-50/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-2xl ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-semibold bg-background-950/70 text-background-50 backdrop-blur-sm whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">{item.subtitle}</p>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}